import { Capacitor } from '@capacitor/core';

/** Afficher le CTA Premium (Reader App iOS : pas de promotion d'achat in-app). */
export function canShowPremiumUpsell(isPremium: boolean | undefined): boolean {
  if (isPremium) return false;
  if (Capacitor.getPlatform() === 'ios' && Capacitor.isNativePlatform()) {
    return false;
  }
  return true;
}
